module.exports = __webpack_public_path__ + "static/heartstarvelour-38cadf5cfbf451da075d950f96587cab.jpeg";